export const FETCH_SIZE_PREFERENCES_REQUEST = 'FETCH_SIZE_PREFERENCES_REQUEST'
export const FETCH_SIZE_PREFERENCES_SUCCESS = 'FETCH_SIZE_PREFERENCES_SUCCESS'
export const FETCH_SIZE_PREFERENCES_ERROR = 'FETCH_SIZE_PREFERENCES_ERROR'

export const FETCH_LOYALTY_CONSENT_REQUEST = 'FETCH_LOYALTY_CONSENT_REQUEST'
export const FETCH_LOYALTY_CONSENT_SUCCESS = 'FETCH_LOYALTY_CONSENT_SUCCESS'
export const FETCH_LOYALTY_CONSENT_ERROR = 'FETCH_LOYALTY_CONSENT_ERROR'
